import { render, staticRenderFns } from "./CreateKeywords.vue?vue&type=template&id=46327fb6&scoped=true"
import script from "./CreateKeywords.vue?vue&type=script&lang=js"
export * from "./CreateKeywords.vue?vue&type=script&lang=js"
import style0 from "./CreateKeywords.vue?vue&type=style&index=0&id=46327fb6&prod&lang=css"
import style1 from "./CreateKeywords.vue?vue&type=style&index=1&id=46327fb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46327fb6",
  null
  
)

export default component.exports